import { createAllActions } from '@api/createRequestStore';
import * as types from './types';

export const fetchTimelineData = (pageType) => ({
  type: types.GET_TIMELINE_DATA,
  pageType
});

const { init: initRequest, fetching, setResponse } = createAllActions(types.SCOPE);
export { initRequest, fetching, setResponse };
